<script setup lang="ts">
import { TimesIcon } from "@voltalis/ui-kit/icons";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";
import BaseDialog from "@/components/ui/dialog/base-dialog.vue";

const emits = defineEmits<{
  (e: "hide"): void;
}>();

const visible = defineModel<boolean>({
  required: false,
  default: false,
});

const { t, k } = useTypedIntl();
</script>

<template>
  <BaseDialog
    v-model:visible="visible"
    modal
    @hide="emits('hide')"
    size="medium"
  >
    <template #container="{ closeCallback }">
      <div class="p-dialog-custom-container">
        <div class="p-dialog-custom-container__header flex flex-col gap-1 border-b">
          <div class="flex justify-between items-start gap-4">
            <slot name="title" />

            <div class="p-dialog-header-actions">
              <HospitalityButton
                :aria-label="t(k.global.misc.close)"
                :data-test-id="DATA_TEST_IDS.views.dashboard.dialog.headerCloseButton"
                :icon="TimesIcon"
                severity="tertiary"
                size="xs"
                @click="closeCallback"
              />
            </div>
          </div>

          <div
            v-if="$slots.subtitle"
            class="p-dialog-custom-container__subtitle"
          >
            <slot name="subtitle" />
          </div>
        </div>

        <div class="p-dialog-custom-container__content">
          <slot />
        </div>

        <div class="p-dialog-custom-container__footer border-t">
          <slot
            :close-callback="closeCallback"
            name="footer"
          >
            <div class="flex justify-end">
              <HospitalityButton
                class="w-full"
                :data-test-id="DATA_TEST_IDS.views.dashboard.dialog.footerCloseButton"
                :label="t(k.global.misc.close)"
                severity="secondary"
                @click="closeCallback"
              />
            </div>
          </slot>
        </div>
      </div>
    </template>
  </BaseDialog>
</template>
